import React, { useEffect, useState } from 'react';
import { Badge } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { setOverviewFiltersFocus } from '@/redux/OverviewFilters/overviewFilters.action';
import { getFilterToFocus } from '@/redux/OverviewFilters/overviewFilters.reducer';
import styles from './FilterSelectionOverview.module.scss';
import FilterSelection from '../FilterSelection/FilterSelection';
import { IcoButtonSimple } from '../IcoButton/IcoButton';

type FilterSelectionOverviewProps = {
  badgeCount?: number;
  isSubCROverview?: boolean;
  filterToFocus: string | null;
  setOverviewFiltersFocus: (field: string) => {
    type: string;
    payload: any;
  };
};

const FilterSelectionOverview: React.FC<FilterSelectionOverviewProps> = (props) => {
  const { badgeCount = 0, isSubCROverview, filterToFocus, setOverviewFiltersFocus } = props;
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);
  const width = isOpen ? 300 : 80;

  const changeWidth = () => {
    setIsOpen(!isOpen);

    if (isOpen) setOverviewFiltersFocus('');
  };

  useEffect(() => {
    if (filterToFocus && !isOpen) {
      setIsOpen(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterToFocus]);

  return (
    <div className={styles.Section} style={{ width: `${width}px` }}>
      <div id="filter-title" className={isOpen ? `${styles.Title} ${styles.BorderTitle}` : styles.Title}>
        {badgeCount !== 0 && (
          <Badge className={styles.badgeDashboard} badgeContent={badgeCount} color="primary" overlap="rectangular">
            <IcoButtonSimple id="btn-filter-campaign-overview" icon="icon-filter" handleClick={changeWidth} />
          </Badge>
        )}
        {badgeCount === 0 && <IcoButtonSimple id="btn-filter-campaign-overview" icon="icon-filter" handleClick={changeWidth} />}
        {isOpen && <span>{t('campaignRequests.filtersOverview')}</span>}
      </div>
      {isOpen && <FilterSelection badgeCount={badgeCount} isSubCROverview={isSubCROverview} />}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  filterToFocus: getFilterToFocus(state),
});

const actionCreators = {
  setOverviewFiltersFocus: setOverviewFiltersFocus,
};

export default connect(mapStateToProps, actionCreators)(FilterSelectionOverview);
